import React from 'react';
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";


const convertDate = (dateString) => {
    const date = new Date(dateString);
    const months = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
};

export default function BlogContent({data}) {

  return (
    <>
    <section className="blogdetail-page header-gap">
        <div className="container">
           <div className="row justify-content-center">

                <div className="col-lg-10">
                    <div className="blogdetail-head">
                        <label><span>{convertDate(data?.created_at)}</span></label>
                        <h1 className="heading">{data?.title}</h1>
                    </div>

                    <div className="para-blogdetail">
                        <p>{data?.content}</p>
                        
                        <div>
                            <span>Share:</span>
                            <ul className="blogdetail-social">
                                <li><Link to={"https://www.facebook.com/SayshaInterior"} target="_blank" aria-label="Facebook"><Icons name="facebook"/></Link></li>

                                <li><Link to={"https://www.linkedin.com/company/saysha-interiors-pvt-ltd"} target="_blank" aria-label="linkedin"><Icons name="linkedin"/></Link></li>

                                <li><Link to={"https://twitter.com/sayshainteriors"} target="_blank" aria-label="twitter"><Icons name="twitter" /></Link></li>
                            </ul>
                        </div>
                    </div>

                    <img src={`${BaseUrl}${data?.banner_image}`} className="blogimage animate__animated wow animate__slideInUp" data-wow-duration="1s" data-wow-delay="0.2s" alt="blog" loading="lazy"/>
                </div>

                <div className="col-lg-10">
                    <div className="blogdetail-content">
                        <div dangerouslySetInnerHTML={{__html:data?.first_description}}/>

                        {Array.isArray(data?.images) && data.images.length > 0 && (
                        <div className="blogcontent-image">
                        {data.images.map((img, idx) => (
                            <img src={`${BaseUrl}${img}`} key={idx} className="img-responsive" alt="blog" loading="lazy"/>
                        ))}
                        </div>
                        )}

                        <div dangerouslySetInnerHTML={{__html:data?.second_description}}/>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
